/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;height:200px;width:500px;border:1px solid #ccc;font-size:var(--font-size-default)}\n/*# sourceMappingURL=feat-d3-statistics.component.css.map*/"];
export { styles as styles };
